module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryouts'
      }
    }
  }, [_vm._v("Tryout")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Tryout Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Langkah " + _vm._s(_vm.step) + " ( " + _vm._s(_vm.stepName[_vm.step - 1]) + " )")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.step == 1) ? _c('app-tryoutform', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.step == 2) ? _c('app-subtestlist', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.step == 3) ? _c('app-tryoutreview', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      }
    }
  }) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4222e1f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tryout/Form.vue
// module id = 1330
// module chunks = 0